import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Nav, NavItem, Row, Col, ButtonToolbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import Calendar, { getDefaultCalendarView, dateRangeByView } from './calendarView/Calendar';
import BookingOptions from './calendarView/BookingOptions';
import GradesDropdown from '../../common/components/GradesDropdown';
import moment from 'moment';
import { withNamespaces, Trans } from 'react-i18next';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import availabilityUtils from './availabilityUtils';
import RecommendedNearbyCenters from './RecommendedNearbyCenters';

class Class extends Component {
	constructor(props) {
		super(props);

		this.handleTermSelect = this.handleTermSelect.bind(this);
		this.handleCalendarNavigate = this.handleCalendarNavigate.bind(this);

		this.state = {
			selectedDate: new Date()
		};
	}

	componentDidMount() {
		if (this.props.bookingOptions.selectedPaymentTypeId || this.props.bookingOptions.isSelectJoinWaitingList ||
			(this.props.bookingOptions.programId && this.props.bookingOptions.date && this.props.bookingOptions.selectedChildId)) {
			this.props.onValidateBookingOptions();	// validate selected options and continue to Confirm
		}

		if (this.props.selectedTerm) {
			this.initCalendarForTerm(this.props.selectedTerm);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.selectedTerm.id !== nextProps.selectedTerm.id || this.props.selectedTerm.startDate !== nextProps.selectedTerm.startDate) {	// term dates might differ between centers
			this.initCalendarForTerm(nextProps.selectedTerm);
		}
	}

	initCalendarForTerm(term) {
		const calendarDate = this.getCalendarInitialDateForTerm(term);
		this.handleCalendarNavigate(calendarDate, term);
	}

	handleTermSelect(termId) {
		this.props.onSelectTerm(termId);
		this.props.onUnselectLesson();
	}

	handleCalendarNavigate(date, term) {
		this.setState({ selectedDate: date });

		const selectedTerm = term || this.props.selectedTerm;

		const canNavigate = this.props.selectedCenter.allowFutureBooking || this.props.bookingOptions.lessonType === 'makeup';
		const { from, to } = dateRangeByView(getDefaultCalendarView(canNavigate), date, this.getStartOfTermWeekday(selectedTerm));
		this.props.onCalendarNavigate(from, to);
	}

	getCalendarInitialDateForTerm(term) {
		const today = new Date();
		const startOfTerm = term && term.id ? new Date(term.startDate) : today;
		return today > startOfTerm ? today : startOfTerm;
	}

	getStartOfTermWeekday(term) {
		return term ? moment(term.startDate).isoWeekday() : 1;
	}

	renderTermsSelector() {
		const { terms, selectedTerm } = this.props;
		const sortedTerms = terms.sort(function (a, b) {
			return moment(a.startDate).format('YYYYMMDD') - moment(b.startDate).format('YYYYMMDD');
		});

		return <Nav bsStyle="tabs" activeKey={selectedTerm.id} onSelect={key => this.handleTermSelect(key)}>
			{sortedTerms.map(term => {
				return <NavItem key={term.id} eventKey={term.id}>
					<div>{term.name}</div>
					<div>{moment(term.startDate).format('DD/MM')} - {moment(term.endDate).format('DD/MM')}</div>
				</NavItem>;
			})}
		</Nav>;
	}

	getPageTitleKey(lessonType) {
		let titleResource = 'FO_Booking_Class_Title';
		switch (lessonType) {
			case 'trial':
				titleResource = 'FO_Booking_Class_Trial';
				break;
			case 'makeup':
				titleResource = 'FO_Booking_Class_MakeUp';
				break;
		}
		return titleResource;
	}

	render() {
		const { lessons, selectedLesson, grades, selectedGrades, onSelectGrades, selectedCenter, terms, selectedTerm, allowWorkshops,
			bookingOptions: { selectedChildId, lessonType }, t, centers, recommendNearbyCenters, distanceToNearbyCenters } = this.props;

		const initialDate = this.getCalendarInitialDateForTerm(selectedTerm);
		const gradeIds = !selectedGrades || selectedGrades.length === 0 ? null : selectedGrades.map(x => x.id);
		const lessonsInSelectedCenterTermAndGrades = lessons.filter(x => x.centerId === selectedCenter.id && x.termId === selectedTerm.id &&
			(!gradeIds || gradeIds.indexOf(x.gradeId) > -1 || (x.grade.mixed && x.grade.subGrades && x.grade.subGrades.some(s => gradeIds.indexOf(s) > -1))));

		const alternativeCenters = (selectedLesson &&
			availabilityUtils.getLessonAvailability(selectedLesson, lessonType) === 'No' &&
			recommendNearbyCenters &&
			availabilityUtils.findNearbyCentersWithAvailableSpotsByLesson(selectedCenter, selectedLesson, lessonType, centers, lessons, distanceToNearbyCenters)) || [];

		return (
			<div>
				<div className={`steps_title ${this.props.selectedLesson ? 'hidden-xs' : ''}`}>
					<Trans i18nKey={this.getPageTitleKey(lessonType)}>
						Select age appropriate class in <CenterDetailsLink center={selectedCenter} hideMapMarker />
					</Trans>
				</div>
				<div className={this.props.selectedLesson ? 'calendar-container hidden-xs' : 'calendar-container'}>
					{terms.length > 0 && this.renderTermsSelector()}
					{terms.length == 0 && <div style={{ textAlign: 'center', margin: '20px 0' }} className='text-muted'>{t('FO_Program_NoAvailableClasses')}</div>}
					{selectedTerm.id > 0 && <div style={{ padding: '10px', background: '#fff', border: '1px solid #ddd', borderTop: 'none' }}>
						<ButtonToolbar className='timetable-search' style={{ marginBottom: '10px' }}>
							<GradesDropdown
								grades={grades.filter(x => !x.mixed).sort((a, b) => a.fromAge < b.fromAge ? -1 : 1)}
								selectedGrades={selectedGrades}
								onSelectGrades={onSelectGrades}
							/>
						</ButtonToolbar>
						<Calendar date={this.state.selectedDate}
							startOfWeek={this.getStartOfTermWeekday(selectedTerm)}
							canNavigate={selectedCenter.allowFutureBooking || lessonType === 'makeup'}
							initialDate={initialDate}
							lessonType={lessonType}
							lessons={lessonsInSelectedCenterTermAndGrades}
							enableUserTimeZone={this.props.enableUserTimeZone}
							center={selectedCenter}
							onNavigate={this.handleCalendarNavigate}
							onSelectLesson={this.props.onSelectLesson}
							calendarBlock={this.props.calendarBlock}
							calendarUnblock={this.props.calendarUnblock}
						/>
					</div>}
					<Row style={{ paddingTop: '10px' }}>
						<Col sm={12}>
							{allowWorkshops && <Link className='btn btn-primary btn-block-xxs pull-right' to={`/public/workshops?centerId=${selectedCenter && selectedCenter.id}`}>{t('FO_MainMenu_Parent_Workshops')} <FontAwesome name='arrow-circle-right' /></Link>}
							<Button className='btn btn-back btn-block-xxs' onClick={this.props.onNavigateBack}><FontAwesome name='arrow-circle-left' /> {t('FO_Booking_Center_Select')}</Button>
						</Col>
					</Row>
				</div>
				<div className={!this.props.selectedLesson ? 'booking-options-container hidden-xs' : 'booking-options-container'}>
					<BookingOptions
						children={this.props.children}
						selectedLesson={this.props.selectedLesson}
						enableUserTimeZone={this.props.enableUserTimeZone}
						bookingOptions={this.props.bookingOptions}
						onCancel={this.props.onUnselectLesson}
						onConfirm={this.props.onSaveBooking}
						onSelectPaymentType={this.props.onSelectPaymentType}
						onJoinWaitingList={this.props.onSelectJoinWaitingList}
						onSelectChild={() => { }}
						block={this.props.bookingOptionsBlock}
						unblock={this.props.bookingOptionsUnblock}
						blockChildrenInfo={this.props.childrenInfoBlock}
						unblockChildrenInfo={this.props.childrenInfoUnblock}
						enableCurrencyConversion={this.props.enableCurrencyConversion}
						currentCurrency={this.props.currentCurrency}
						franchisorCurrency={this.props.franchisorCurrency}
						isAuthenticated={true}
						selectedTerm={selectedTerm}
						centerId={selectedCenter && selectedCenter.id}
					/>
				</div>
				{alternativeCenters.length > 0 && <div className='booking-options-container' style={{ background: 'none', border: 'none', boxShadow: 'none' }}>
					<RecommendedNearbyCenters
						centers={alternativeCenters}
						onSelectCenter={this.props.onSelectNearbyCenter}
					/>
				</div>
				}
			</div>
		);
	}
}

Class.propTypes = {
	grades: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	selectedGrades: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	onSelectGrades: PropTypes.func.isRequired,
	lessons: PropTypes.arrayOf(PropTypes.shape({
		programId: PropTypes.number,
		grade: PropTypes.shape({
			name: PropTypes.string
		}),
		start: PropTypes.string,
		end: PropTypes.string
	})),
	enableUserTimeZone: PropTypes.bool,
	onValidateBookingOptions: PropTypes.func.isRequired,
	onCalendarNavigate: PropTypes.func.isRequired,
	onSelectLesson: PropTypes.func.isRequired,
	onUnselectLesson: PropTypes.func.isRequired,
	onSelectTerm: PropTypes.func.isRequired,
	onSelectPaymentType: PropTypes.func.isRequired,
	onSelectJoinWaitingList: PropTypes.func.isRequired,
	onSaveBooking: PropTypes.func.isRequired,
	onNavigateBack: PropTypes.func.isRequired,
	terms: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		startDate: PropTypes.string,
		endDate: PropTypes.string
	})),
	selectedTerm: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		startDate: PropTypes.string,
		endDate: PropTypes.string,
		themeDescription: PropTypes.string
	}),
	children: PropTypes.arrayOf(PropTypes.shape({
		shortName: PropTypes.string,
		hasTrialLesson: PropTypes.boolean,
		ageAppropriateGrades: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }))
	})),
	recommendNearbyCenters: PropTypes.boolean,
	onSelectNearbyCenter: PropTypes.func
};

export default withNamespaces()(Class);